module.exports = __webpack_public_path__ + "static/img/15.779104e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/15.jpg
// module id = KOnI
// module chunks = 0